import { FSA } from '../../shared/types'
import { Appointment, AppointmentAvailability, AppointmentState, AppointmentDate } from './appointment.types'
import { APPOINTMENT_DATE, APPOINTMENT_SELECTED } from './appointment.actions'

export const initialState: AppointmentState = {
  appointmentAvailabilityCache: {},
  selectedAppointment: null
}

export function reducer(
  state: AppointmentState | undefined = initialState,
  action: FSA<unknown, { cacheKey: string }>
): AppointmentState {
  switch (action.type) {
    case APPOINTMENT_DATE.SUCCESS: {
      const { cacheKey } = action.meta
      const newAppointmentDate = action.payload as AppointmentDate
      const existingDates = state.appointmentAvailabilityCache[cacheKey]?.dates || []
      const dateExists = existingDates.some(d => d.date.getTime() === newAppointmentDate.date.getTime())
      let updatedDates: AppointmentDate[]

      if (dateExists) {
        updatedDates = existingDates.map(d => (d.date.getTime() === newAppointmentDate.date.getTime() ? newAppointmentDate : d))
      } else {
        updatedDates = [...existingDates, newAppointmentDate]
      }

      return {
        ...state,
        appointmentAvailabilityCache: {
          ...state.appointmentAvailabilityCache,
          [cacheKey]: {
            ...state.appointmentAvailabilityCache[cacheKey],
            dates: updatedDates
          }
        }
      }
    }
    case APPOINTMENT_SELECTED:
      return {
        ...state,
        selectedAppointment: action.payload as Appointment
      }
    default:
      return state
  }
}
